import { useContext, useState } from "react"
import { AppCenterPopupD2, CenterPopupHeaderD2 } from "src/component"
import VisibilityContext from 'src/provider/state-manager/visibilityProvider'
import ApiContext from 'src/provider/API/call-service'
import { FlexRow, Button, CustomContainer, FormGroup } from "src/style"
import { HiOutlineStar, HiStar } from 'react-icons/hi'


export const RateAccountOfficerD2: React.FC<any> = ({data, close}) => {
    const {notifier} = useContext(VisibilityContext)
    const {API} = useContext(ApiContext)
    const [rating, setRating] = useState(data?.rating?.ratingValue || 0)
    const [comment, setComment] = useState('')

    async function handleSubmit () {
        await API.saveAccountOfficerRating(data?.details?.code, rating)
        close()
    }
    
    return (
        <AppCenterPopupD2 height='48' zIndex='6' overflow='hidden' close={close}>
            <CenterPopupHeaderD2 title='Rate Account Officer' close={close} />
            <CustomContainer height="37" className='popup-content-container'>
                <CustomContainer  topMargin='2'>
                    <FlexRow justifyContent='center' gap='1.5'>
                        {
                            Array.from(Array(5).keys()).map((item: any) => {
                                
                                return (
                                    item+1 <= rating ?
                                        <HiStar 
                                            style={{color: '#F79D56', fontSize: '5rem'}} 
                                            key={item}
                                            onClick={() => setRating(item + 1)}
                                        />
                                        :
                                        <HiOutlineStar 
                                            style={{color: '#200E32', fontSize: '5rem'}} 
                                            key={item}
                                            className='bs-star'
                                            onClick={() => setRating(item + 1)}
                                        />
                                )
                            })
                        }
                    </FlexRow>
                    <FormGroup height='12.8' topMargin='2'>
                        <label>Comments</label>
                        <textarea 
                            placeholder='Enter Comments...' 
                            name='comment'
                            value={comment}
                            onChange={(e) => setComment(e.target.value)}
                            //required
                        />
                    </FormGroup>
                    <Button 
                        width='100' sizeUnit="%" height='4.4' 
                        borderColor='#0D968F' hoverBgColor='#fff' 
                        hoverColor='#0D968F' bottomMargin='0.5'
                        onClick={handleSubmit}
                    >
                        Proceed
                    </Button>
                </CustomContainer>
            </CustomContainer>
        </AppCenterPopupD2>
    )
}
